import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";

interface TimeElapsedProps {
  countdownFrom?: number;
  onComplete?: () => void;
}

export const TimeElapsed: React.FC<TimeElapsedProps> = ({
  countdownFrom,
  onComplete,
}) => {
  const [secondsElapsed, setSecondsElapsed] = useState(countdownFrom || 0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSecondsElapsed((prevSeconds) => {
        if (countdownFrom && prevSeconds > 0) {
          return prevSeconds - 1;
        } else if (!countdownFrom) {
          return prevSeconds + 1;
        } else {
          return prevSeconds;
        }
      });
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [countdownFrom]);

  useEffect(() => {
    if (countdownFrom && secondsElapsed === 0) {
      onComplete?.();
    }
  }, [secondsElapsed, countdownFrom, onComplete]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  return (
    <Typography
      display={"flex"}
      width={"100%"}
      justifyContent={"center"}
      sx={{
        fontFamily: "monospace",
        color: "#FFFFFF",
        fontWeight: "600",
        fontSize: 20,
        textAlign: "center",
      }}
    >
      {formatTime(secondsElapsed)}
    </Typography>
  );
};
